import { AccessPermissions } from '../../core/types.js';

/**
 * Means this page/content is only visible to unauthenticated users.
 * If a user is authenticated, they should not be allowed to see this content.
 * A page like our Sign-Up page should be inaccessible to authenticated users.
 */ const PUBLIC_ONLY = {
    access: AccessPermissions.publicOnly
};

export { PUBLIC_ONLY };
//# sourceMappingURL=publicOnly.js.map
